<template>
    <div>
        <div class="hero-banner js-hero-banner">
            <div
                class="banner-item position-relative"
                v-for="(slide, index) in sliders"
                :key="index"
            >
                <picture>
                    <source
                        media="(max-width: 479px)"
                        :srcset="slide.mobileImage"
                    />
                    <img :src="slide.image" :alt="slide.title" />
                </picture>
                <!-- <h2 v-html="slide.title"></h2> -->
            </div>
        </div>
        <div class="b-container">
            <div class="overview">
                <!-- <h1>OverView</h1> -->
                <p>
                    X-Index Companies (XIC) is a leading business conglomerate
                    in Bangladesh, founded in 1977. Over the past four decades,
                    XIC has grown from its origins in architecture consultancy
                    into a dynamic player across various sectors, including real
                    estate, animal feed manufacturing, agriculture, ceramics,
                    power & energy, and hospitality.
                </p>

                <p class="pt-3">
                    Our journey began with architectural services, expanding
                    into real estate in 1999. In 2000, motivated by a commitment
                    to food security, we entered the agriculture sector. In
                    2021, we successfully took our premier agriculture company
                    into publicly listed. In 2009, we ventured into the ceramics
                    tile industry to provide high-quality building materials and
                    reduce import dependency, quickly establishing ourselves as
                    one of the largest manufacturers in Bangladesh. Our
                    dedication to energy has led us to invest in fuel-based
                    power plants in 3 different location of Bangladesh that
                    contribute to the national grid, and our hospitality
                    division operates a chain of hotels nationwide.
                </p>
                <p class="pt-3">
                    As we transition to XIC, we aim to showcase our commitment
                    to sustainability and innovation. This rebranding represents
                    more than just a name change; it encapsulates our vision for
                    the future, emphasizing shared ownership and digital
                    innovation.
                </p>
                <p class="pt-3">
                    By 2050, we aspire to create an organization where employees
                    feel empowered as stakeholders, fostering collaboration and
                    shared values.
                </p>
                <p class="pt-3">
                    Our rebranding highlights the core values guiding our
                    mission:
                    <ul class="pt-2 pl-5" style="list-style-type: disc">
                        <li>
                          Pure: Upholding integrity and transparency in all interactions.
                        </li>
                        <li>
                            Simple: Ensuring clarity and efficiency in our processes.
                        </li>
                        <li>
                            Respectful: Valuing diverse perspectives and ensuring every voice is acknowledged.
                        </li>
                        <li>
                            Impactful: Striving to make a positive difference in our country and beyond.
                        </li>
                    </ul>
                </p>
                <p class="pt-3">
                    We are committed to embracing digital transformation to
                    enhance our operations and customer experiences, aligning
                    with our vision of a sustainable organization.
                </p>
            </div>
        </div>

        <div class="overview-image">
            <div class="b-container">
                <div class="row">
                    <div
                        class="col item"
                        v-for="(company, index) in companies"
                        :key="index"
                    >
                        <a
                            :href="
                                $root.siteConfig.routes.details.replace(
                                    'name',
                                    company.name
                                )
                            "
                        >
                            <div class="box position-relative">
                                <img :src="company.image" alt="image" />
                                <div
                                    class="cover d-flex align-items-end justify-content-center"
                                >
                                    <div class="text-center">
                                        <strong
                                            v-text="
                                                'Established in ' +
                                                company.established
                                            "
                                        ></strong>
                                        <h3 v-text="company.title"></h3>
                                    </div>
                                </div>
                                <div class="hover-content d-flex">
                                    <div class="center-content">
                                        <!-- <div class="hover-logo d-flex">
                                            <img
                                                :src="company.logo"
                                                :alt="company.title"
                                            />
                                        </div> -->
                                        <h3 v-text="company.title"></h3>
                                        <p v-text="company.desc"></p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="home-video position-relative">
            <video
                autoplay=""
                playsinline="true"
                webkit-playsinline="true"
                muted="muted"
                id="movie"
                :src="video.link"
            ></video>
        </div>

        <div class="logo-item">
            <div class="b-container">
                <div class="row item-slider">
                    <div
                        v-for="(com, index) in companies"
                        :key="index"
                        class="col-md-2"
                    >
                        <a
                            :href="
                                $root.siteConfig.routes.details.replace(
                                    'name',
                                    com.name
                                )
                            "
                        >
                            <div
                                class="logo-holder d-flex align-items-center justify-content-center"
                            >
                                <img
                                    class="img-fluid"
                                    :src="com.logo"
                                    alt="image"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            indexCompaniesLifeTime:
                new Date().getFullYear() - new Date("1977,01,01").getFullYear(),
            video: this.$root.siteConfig.video,
            sliders: this.$root.siteConfig.sliders,
            companies: this.$root.siteConfig.companies,
        };
    },
    // created() {
    //     this.$root.getSummary();
    // }
};
</script>
